import React, { useState } from "react";
import BrandIdentityModal from "../modal/BrandIdentityModal";
import { useCompanyStore } from "../../../state/useCompanyStore";

const UpdateBrandTheme = ({ center = false }: { center?: boolean }) => {
  const [open, setOpen] = useState(false);
  const { company: user } = useCompanyStore();
  return (
    <>
      <div className={`mt-6 ${center && "flex justify-center items-center"}`}>
        <button
          type="button"
          onClick={() => setOpen(!open)}
          className="flex items-center gap-2 p-1.5 pr-2 bg-[#F2F4F7] rounded-full w-auto"
        >
          <span
            style={{
              backgroundColor: user?.brandColor || "#000000", // Fallback color
            }}
            className={`h-6 w-6 rounded-full`}
          ></span>
          <span className="text-sm font-medium">Customize your invoices</span>
        </button>
      </div>
      {open && (
        <BrandIdentityModal showLogo={false} onClose={() => setOpen(!open)} />
      )}
    </>
  );
};

export default UpdateBrandTheme;
